import { DocumentNode } from "apollo-boost";

export async function fetchGraphQL(
  query: DocumentNode,
  variables?: Record<string, any>
) {
  return fetch("/api/graphql-client-query", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then((res) => res.json());
}
